import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Classes from '../../../common/Classes';
import Utils from '../../../common/Utils';
import mixpanelConstants from '../../../common/mixpanelConstants';

const Name = props => (
  <div data-testid='name-control'
      onClick={() => props.triggerMixpanelEvent(mixpanelConstants.element.exhibitorTitle)}>
    <a
      href={props.detailPageLink}
      data-dtm={props.exhibitor.isPrioritySlotPremiumExhibitor ? props.tags.exhibitorName + props.tags.prioritySlot : props.tags.exhibitorName}
      data-dtm-attributes={JSON.stringify({ exhibitorId: props.exhibitor.id,
        package: Utils.getPackageName(props.exhibitor.packageId) })}
    >
      <h3 className={classnames(Classes.exhibitorName,Classes.wrapWord)}>
        {props.exhibitor.name}
      </h3>
    </a>
  </div>
);

Name.propTypes = {
  detailPageLink: PropTypes.string.isRequired,
  exhibitor: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    packageId: PropTypes.number
  }).isRequired,
  tags: PropTypes.shape({
    exhibitorName: PropTypes.string,
    prioritySlot: PropTypes.string
  }),
  triggerMixpanelEvent: PropTypes.func,
};

export default Name;
